import { Languages } from "lucide-react";
import { useI18n } from "@/i18n";
import { Button } from "./ui/button";

export function LanguageToggle({ onChange }: { onChange?: (locale: "bn" | "en") => void }) {
  const { locale, setLocale, t } = useI18n();
  const next = locale === "bn" ? "en" : "bn";
  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label={t("common.language")}
      onClick={() => {
        setLocale(next);
        onChange?.(next);
      }}
    >
      <Languages aria-hidden />
      {next === "en" ? "English" : "বাংলা"}
    </Button>
  );
}
